module.exports = __webpack_public_path__ + "static/img_2275-9e0c866d5d454d6ae6fea604ac7c4a1b.webp";